import * as React from "react";
import { graphql } from "gatsby";
import Seo from "../components/Seo";

import { indexPageData } from "../data/page-index.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";
import Hero from "../componentsSections/Hero";
import ConnectivityLogos from "../components/ConnectivityLogos";
import KeyBenefits from "../componentsSections/KeyBenefits";
import Lottie from "../componentsSections/Lottie";
import SolutionsOverview from "../componentsSections/SolutionsOverview";
import SocialProof from "../componentsSections/SocialProof";
import SecuritySection from "../componentsSections/SecuritySection";
import ImageSection from "../components/ImageSection";

const IndexPage = () => {
    const seoPageData = getCurrentPageSeo("frontpage");
    const pageData = indexPageData();

    return (
        <>
            <Layout
                pageTitle={seoPageData.title}
                navbarVariant={undefined}
                newsletterVariant="dark"
            >
                <Seo post={seoPageData} />

                <Hero
                    {...pageData.hero}
                    textSize="big"
                    className="mb-5"
                    backgroundImage={null}
                    floatingBadges={pageData.heroFloatingBadges?.badges}
                />

                <Section>
                    <ConnectivityLogos
                        variant="dark"
                        {...pageData.logosSection}
                    />
                </Section>

                <Section className="-lottie-spacing">
                    <KeyBenefits className="-light" {...pageData.keyBenefits} />
                </Section>

                <Section className="-mobile-full -lottie-spacing">
                    <Lottie {...pageData.tradeLayer} />
                </Section>

                <Section>
                    <SolutionsOverview {...pageData.solutionsOverview} />
                </Section>

                <Section className="-mobile-full">
                    <SocialProof
                        mode="full"
                        trustedByHeader={pageData.socialProof?.trustedByHeader}
                        trustedByLogos={pageData.socialProof?.trustedByLogos}
                        testimonials={pageData.socialProof?.testimonials}
                        autoplayDelay={3000}
                    />
                </Section>

                <Section className="-mobile-full">
                    <ImageSection
                        containerClassName="pt-2"
                        contentClassName="pt-3"
                        imageSection={pageData.imageSection}
                        flipped
                    />
                </Section>

                <Section className="-mobile-full">
                    <SecuritySection
                        {...pageData.securitySection}
                        layout="split"
                    />
                </Section>

                <PageFooterSections pageData={pageData} />
            </Layout>
        </>
    );
};

export default IndexPage;
